<template>
  <div class="flex flex-col items-start lg:flex-row">
    <div class="mb-3 w-full md:mb-0 lg:mr-12 lg:w-[390px]">
      <slot name="sidebar" />
    </div>

    <div class="w-full lg:w-[calc(100%-390px-48px)]">
      <slot name="main" />
    </div>
  </div>
</template>
